module.exports = __webpack_public_path__ + "static/media/Montserrat-ThinItalic.3c2b290f.ttf";